import { module } from 'modujs';
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { whenReady } from "../utils/fonts";
import { FONT } from "../config";

gsap.registerPlugin(SplitText)

export default class extends module {
    constructor(m) {
        super(m);
        this.onResizeBind = this.onResize.bind(this);
    }

    init() {
        if(window.isReduceMotion) return
        whenReady(FONT.EAGER).then((fonts) => {
            this.split();
            this.introAnimation();
        });
        window.addEventListener("resize", this.onResizeBind)
    }

    split() {
        if(window.isReduceMotion) return

        this.splitObject = new SplitText(this.el, {
            type: "lines, words, chars",
            charsClass: "c-split-text_char"
        });

        gsap.set(this.el, {opacity: 1})
    }

    introAnimation() {
        const direction = this.el.getAttribute("splitDirection");
        const delay = this.el.getAttribute("splitDelay") ?? 0;
        gsap.fromTo(this.splitObject.chars,
            {
                y: '100%',
                opacity: 0
            },
            {
                y: '0',
                opacity: 1,
                stagger: {
                    each: 0.02,
                    from: direction,
                },
                duration: 1,
                delay: delay,
                ease: "power3.out"
            }
        )
    }

    destroy() {
        if(window.isReduceMotion) return

        window.removeEventListener("resize", this.onResizeBind)
    }

    onResize() {
        this.splitObject?.revert();
        this.split();
    }
}
